import { motion, useScroll, useTransform } from "framer-motion";

// Subtle ambient floating geometric motifs.
// Uses global window scroll so no positioning warnings are emitted.
export const FloatingMotif = ({ variant = "light" }) => {
    const { scrollYProgress } = useScroll();
    const y1 = useTransform(scrollYProgress, [0, 1], [0, -40]);
    const y2 = useTransform(scrollYProgress, [0, 1], [0, 40]);
    const rot = useTransform(scrollYProgress, [0, 1], [0, 12]);

    const stroke =
        variant === "dark"
            ? "rgba(255,255,255,0.06)"
            : "rgba(17,17,17,0.05)";
    const dot =
        variant === "dark"
            ? "rgba(255,255,255,0.15)"
            : "rgba(17,17,17,0.15)";

    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <motion.svg
                style={{ y: y1, rotate: rot }}
                className="absolute -top-24 -left-24 w-56 h-56 md:w-72 md:h-72"
                viewBox="0 0 200 200"
                aria-hidden
            >
                <circle cx="100" cy="100" r="80" fill="none" stroke={stroke} strokeWidth="1" strokeDasharray="2 4" />
                <circle cx="100" cy="100" r="55" fill="none" stroke={stroke} strokeWidth="1" />
                <circle cx="100" cy="100" r="2" fill={dot} />
            </motion.svg>
            <motion.svg
                style={{ y: y2, rotate: rot }}
                className="absolute -bottom-32 -right-32 w-64 h-64 md:w-80 md:h-80"
                viewBox="0 0 200 200"
                aria-hidden
            >
                <rect x="20" y="20" width="160" height="160" fill="none" stroke={stroke} strokeWidth="1" />
                <line x1="20" y1="60" x2="180" y2="60" stroke={stroke} strokeWidth="1" strokeDasharray="2 4" />
                <line x1="20" y1="140" x2="180" y2="140" stroke={stroke} strokeWidth="1" strokeDasharray="2 4" />
                <line x1="60" y1="20" x2="60" y2="180" stroke={stroke} strokeWidth="1" strokeDasharray="2 4" />
                <line x1="140" y1="20" x2="140" y2="180" stroke={stroke} strokeWidth="1" strokeDasharray="2 4" />
            </motion.svg>
        </div>
    );
};
